import { render, staticRenderFns } from "./goods-freezer.vue?vue&type=template&id=53a25d84&scoped=true&"
import script from "./goods-freezer.vue?vue&type=script&lang=js&"
export * from "./goods-freezer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a25d84",
  null
  
)

export default component.exports